import { Component, lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { UIProvider } from "@/context/UIContext";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import CustomCursor from "@/components/layout/CustomCursor";
import MouseGlow from "@/components/layout/MouseGlow";
import LenisInit from "@/components/layout/LenisInit";
import RouteScrollFix from "@/components/layout/RouteScrollFix";

const Home = lazy(() => import("@/pages/Home"));
const About = lazy(() => import("@/pages/About"));
const Services = lazy(() => import("@/pages/Services"));
const Portfolio = lazy(() => import("@/pages/Portfolio"));
const Industries = lazy(() => import("@/pages/Industries"));
const Process = lazy(() => import("@/pages/Process"));
const Contact = lazy(() => import("@/pages/Contact"));

class ErrorBoundary extends Component {
    state = { err: false };
    static getDerivedStateFromError() {
        return { err: true };
    }
    componentDidCatch(err) {
        console.error(err);
    }
    render() {
        if (this.state.err)
            return (
                <div className="grid min-h-screen place-items-center bg-navy-900 text-ice">
                    Something went wrong. Please refresh the page.
                </div>
            );
        return this.props.children;
    }
}

function App() {
    return (
        <ErrorBoundary>
            <BrowserRouter>
                <UIProvider>
                    <LenisInit />
                    <RouteScrollFix />
                    <MouseGlow />
                    <CustomCursor />
                    <Header />
                    <Suspense fallback={<div className="min-h-screen" />}>
                        <main>
                            <Routes>
                                <Route path="/" element={<Home />} />
                                <Route path="/about" element={<About />} />
                                <Route path="/services" element={<Services />} />
                                <Route path="/portfolio" element={<Portfolio />} />
                                <Route path="/industries" element={<Industries />} />
                                <Route path="/process" element={<Process />} />
                                <Route path="/contact" element={<Contact />} />
                                <Route path="*" element={<Home />} />
                            </Routes>
                        </main>
                        <Footer />
                    </Suspense>
                </UIProvider>
            </BrowserRouter>
        </ErrorBoundary>
    );
}

export default App;
